import React, { useState } from 'react';
import Button from '../../../../../components/button/Button';
import { VEC_ICON_NAME } from '../../../../../components/icons/constants';
import Icons from '../../../../../components/icons/Icons';
import RadioInput from '../../../../../components/input/radioinput/RadioInput';
import Popup from '../../../../../components/popup/Popup';
import HorizontalSeparator from '../../../../../components/separator/horizontalSeparator/HorizontalSeparator';
import styles from './QuarterSelectionPopup.styles';

export default function QuarterSelectionPopup({
    title = "Quarter Selection",
    bodyText = "Please select the Quarter to download template",
    quarterOptions = [
        {
            "value": "1stQuarter",
            "label": "1st Quarter",
            "description": "",
            "isReadonly": false
        },
        {
            "value": "2ndQuarter",
            "label": "2nd Quarter",
            "description": "",
            "isReadonly": false
        },
        {
            "value": "3rdQuarter",
            "label": "3rd Quarter",
            "description": "",
            "isReadonly": false
        }
    ],
    iconName = VEC_ICON_NAME.WARNING_ICON,
    isOpen,
    confirmationButtonProps = {
        onConfirmationCb: () => { },
        confirmationButtonText: "Submit",
        confirmationButtonStyles: {},
        confirmationButtonType: BUTTON_TYPE.PRIMARY,
    },
    cancelButtonProps = {
        onCancelCb: () => { },
        onCloseCb: () => { },
        cancelButtonText: "Cancel",
        cancelButtonStyles: {},
        cancelButtonType: BUTTON_TYPE.PRIMARY_LIGHT_WITH_BORDER,
    },
    customStyle = {},
    isClose = true,
    showClose = false,
    onChangeCb = () => {},
    disabled,
}){
    const [selectedQuarterInPopup, setSelectedQuarterInPopup] = useState(null);

    const handleConfirmationBtnClick = (quarter) => {
        confirmationButtonProps.onConfirmationCb(quarter);
    }

    return <>
        <Popup title={title} onCloseCb={isClose ? cancelButtonProps?.onCancelCb : cancelButtonProps?.onCloseCb} showClose={showClose} isPopupOpen={isOpen} customPopupSyles={customStyle}>
            <div style={styles.bodyContainer}>
                {iconName && <div>
                    <Icons familyName='vec' iconName={iconName} />
                </div>}

                {bodyText && <span style={styles.bodyText}>{bodyText}</span>}
                <div>
                    {
                        quarterOptions.map(option => <RadioInput
                            label={
                                { suffixLabel: option.label}
                            }
                            value={option.value}
                            name={"quarterSelection"}
                            checked={selectedQuarterInPopup == option.value}
                            onChangeCb={e => setSelectedQuarterInPopup(e.target.value)}
                            disabled={disabled}
                        />)
                    }
                </div>
            </div>

            <HorizontalSeparator style={styles.separatorLine} />

            <div style={styles.footer}>

                {confirmationButtonProps.confirmationButtonText && <div onClick={() => handleConfirmationBtnClick(selectedQuarterInPopup)}>
                    <Button
                        type={confirmationButtonProps.confirmationButtonType}
                        style={{ ...confirmationButtonProps.confirmationButtonStyles, ...styles.button }}
                    >
                        {confirmationButtonProps.confirmationButtonText}
                    </Button>
                </div>}

                {
                    cancelButtonProps !== null && <div onClick={cancelButtonProps.onCancelCb}>
                        <Button
                            type={cancelButtonProps.cancelButtonType}
                            style={{ ...cancelButtonProps.cancelButtonStyles, ...styles.button }}
                        >
                            {cancelButtonProps.cancelButtonText}
                        </Button>
                    </div>
                }

            </div>
        </Popup>
    </>
}